export default "__VITE_ASSET__Cb_BwJ77__"